import { createContext } from 'react'

import type { ActorMember } from '@healthblocks-io/core/types'
import type { AxiosResponse } from 'axios'

type IHealthblocksMemberContext = {
  member?: ActorMember

  getMemberIsLoading?: boolean
  updateMemberIsLoading?: boolean

  clearMember?: () => void
  getMember?: (id: number) => Promise<void | AxiosResponse<ActorMember>> | undefined
  updateMember?: (id: number, updates: Partial<ActorMember>) => Promise<void | AxiosResponse<ActorMember>> | undefined
}

const HealthblocksMemberContext = createContext<IHealthblocksMemberContext>({})

export type { IHealthblocksMemberContext }
export { HealthblocksMemberContext }
